import React from 'react';

import Partners from 'components/HomePage/Partners';
import AboutAwards from 'components/HomePage/AboutAwards';
import WhoWeAre from 'components/HomePage/WhoWeAre';
import CSOShortlist from 'components/HomePage/CSOShortlist';
import Judges from 'components/HomePage/Judges';

const LandingPageItems = () => (
  <div>
    <CSOShortlist />
    <AboutAwards />
    <Judges />
    <WhoWeAre />
  </div>
);

export default LandingPageItems;



// WEBPACK FOOTER //
// ./src/components/HomePage/LandingPageItems.js